import { render, staticRenderFns } from "./best-start-drawer.component.vue?vue&type=template&id=3663ab86&scoped=true"
import script from "./best-start-drawer.component.vue?vue&type=script&lang=js"
export * from "./best-start-drawer.component.vue?vue&type=script&lang=js"
import style0 from "./best-start-drawer.component.vue?vue&type=style&index=0&id=3663ab86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3663ab86",
  null
  
)

export default component.exports